<template>
    <div class="contain">
        <div style="display: flex; justify-content: flex-end">
            <button class="detail-button cursor-pointer" @click="getPdf()">列印 Print</button>
        </div>
        <div
            class="el-icon-back cursor-pointer showPC"
            style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; position: absolute; margin-left: calc(5vw - 2rem); margin-top: 2.25rem"
            @click="onBack"
        ></div>
        <div
            class="el-icon-back cursor-pointer showPhone"
            style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; position: absolute; margin-left: calc(95vw - 1.5rem); margin-top: 2.25rem"
            @click="onBack"
        ></div>
        <div id="pdfDom" style="padding: 2.25rem 5vw">
            <!-- <div class="el-icon-back" style="font-size: 1.5rem;line-height: 2rem;font-weight: bold;position:absolute;margin-left:-2rem" @click="onBack"></div> -->
            <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">訂閱付費紀錄詳細 <span style="white-space: nowrap">Subscribe Record Details</span></div>
            <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
                <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
                <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
                <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
            </div>
            <!-- <div style="display:flex;justify-content:flex-end;">
          <button class="detail-button" style="position:absolute;margin-top:1.5rem;" @click="getPdf()">列印</button>
        </div> -->
            <div>
                <div class="detail-box showPC">
                    <div style="margin-right: 20px">交易編號 Transaction number：{{ tableData.orderNo }}</div>
                    <div style="margin-right: 5.5rem">付費日期 Payment date：{{ formatDateTime(tableData.payedAt) || "---" }}</div>
                    <div style="margin-right: 5.5rem">訂閱學生數目 Subscribed Number：{{ tableData.studentQuantity }}</div>
                </div>
                <div class="detail-box showPhone">
                    <div style="margin-bottom: 1rem">交易編號<br />Transaction number：<br />{{ tableData.orderNo }}</div>
                    <div style="margin-bottom: 1rem">付費日期<br />Payment date：<br />{{ formatDateTime(tableData.payedAt) || "---" }}</div>
                    <div style="margin-bottom: 1rem">訂閱學生數目<br />Subscribed Number：<br />{{ tableData.studentQuantity }}</div>
                    <div style="margin-bottom: 1rem">總計<br />Total：<br />{{ addComma(tableData.payPrice) }}</div>
                </div>
                <div class="table-box" ref="print">
                    <el-table :data="tableData.orderItems" style="width: 100%">
                        <el-table-column prop="student" :label="'學生帳戶\nStudent Account'" width="300"> </el-table-column>
                        <el-table-column prop="grade" :label="'年級\nGrade'" width="200">
                            <template slot-scope="{ row }">
                                {{ row.grade}}
                            </template>
                        </el-table-column>
                        <el-table-column :label="'訂閱時段\nSubscription Period'" width="240" :formatter="dateFormatter"> </el-table-column>
                        <el-table-column prop="price" :label="'價格\nPrice'" min-width="260" align="right" :formatter="priceFormatter"> </el-table-column>
                    </el-table>
                    <div class="price-box">
                        <div>小計 Subtotal：</div>
                        <div style="width: 10rem">{{ addComma(tableData.totalPrice) }}</div>
                    </div>
                    <div class="price-box">
                        <div>折扣 Discount：</div>
                        <div style="width: 10rem">
                            {{ addComma(tableData.totalPrice - tableData.payPrice) }}
                        </div>
                    </div>
                    <div v-if="tableData.promotionCode" class="price-box" style="color: #b62d2e; font-weight: bold">
                        <div>已使用推廣碼 Used Promotion Code：</div>
                        <div style="width: 10rem">{{ tableData.promotionCode }}</div>
                    </div>
                    <div class="price-box">
                        <div>總計 Total：</div>
                        <div style="width: 10rem">{{ addComma(tableData.payPrice) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
import { formatDate, formatDateTime2 } from "@/filters";
export default {
    props: {
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            tableData: {},
            enGradeList: {
                小一: "Primary One",
                小二: "Primary Two",
                小三: "Primary Three",
                小四: "Primary Four",
                小五: "Primary Five",
                小六: "Primary Six",
            },
            htmlTitle: "訂閱付費紀錄詳細 Subscribe Record Details",
        };
    },
    watch: {
        "$store.getters.language": {
            handler() {
                //  this.getCarts()

                this.$forceUpdate();
            },
            deep: true,
        },
    },
    created() {},
    mounted() {
        this.getOrderDetail(this.id);
    },
    methods: {
        getOrderDetail(id) {
            getOrderDetail(id).then((v) => {
                this.tableData = v.data;
                this.htmlTitle = this.tableData.orderNo;
            });
        },
        dateFormatter(row) {
            return this.addDate(row.startDate);
        },
        addDate(date) {
            var start = new Date(date);
            var end = new Date(date);
            end.setFullYear(end.getFullYear() + 1);
            end.setDate(end.getDate() - 1);
            return formatDate(start) + " - " + formatDate(end);
        },
        formatDateTime(date) {
            return formatDateTime2(date);
        },
        priceFormatter(row) {
            return this.addComma(row.price);
        },
        addComma(num, i) {
            if (i == 1) return num ? `- HKD $${num.toLocaleString()}` : "---";
            return num ? `HKD $${num.toLocaleString()}` : "---";
        },
    },
};
</script>

<style lang="scss" scoped>
.detail-box {
    display: flex;
    margin-top: 2rem;
    flex-wrap: wrap;
}
.showPC {
    display: block;
}
.showPhone {
    display: none;
}
.table-box {
    padding: 1.25rem 0;
}
.detail-button {
    font-size: 1rem;
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    color: #444444;
    border-radius: 1.625rem;
    line-height: 2.5;
    //height: 2.5rem;
    //width: 5rem;
    background: none;
    position: absolute;
    margin-top: 8.75rem;
    margin-right: 5vw;
}
.price-box {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    margin-top: 1rem;
    margin-right: 8rem;
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .contain {
        height: 100%;
    }
    .detail-box {
        flex-direction: column;
        border-bottom: 1px solid black;
    }
    .showPC {
        display: none;
    }
    .showPhone {
        display: block;
    }
    .detail-button {
        margin-top: 9.75rem;
    }
}
::v-deep {
    .el-table {
        font-size: 1rem;
    }
    .el-table .cell {
        padding: 0;
    }
    .el-table th.el-table__cell > .cell {
        padding: 0;
        white-space: pre-wrap;
    }
    .el-table th {
        background: #fceedd;
        color: #444444;
    }
    .el-table th:first-child {
        padding-left: 6rem;
    }
    .el-table td:first-child {
        padding-left: 6rem;
    }
    .el-table th:nth-child(4) {
        padding-right: 8rem;
    }
    .el-table td:last-child {
        padding-right: 8rem;
    }
}
</style>
